import { sortByKeyValue } from "@/utils/sorters";
import { isPending } from "@/utils/trips";
import { equalsUsingDifferences } from "@/utils/arrays";

const RESET = "RESET";
const SET_TRIPS = "SET_TRIPS";
const SET_SERVICES = "SET_SERVICES";
const SET_HISTORIC_TRIPS = "SET_HISTORIC_TRIPS";

const initialState = () => ({
  trips: [],
  services: [],
  historicTrips: [],
});

const state = initialState();

const mutations = {
  [SET_TRIPS]: (state, trips) => {
    if (!equalsUsingDifferences(state.trips, trips)) {
      state.trips.splice(0, state.trips.length);
      state.trips.push(...trips);
    }
  },
  [SET_SERVICES]: (state, services) => {
    if (!equalsUsingDifferences(state.services, services)) {
      state.services.splice(0, state.services.length);
      state.services.push(...services);
    }
  },
  [SET_HISTORIC_TRIPS]: (state, historicTrips) => {
    if (!equalsUsingDifferences(state.historicTrips, historicTrips)) {
      state.historicTrips.splice(0, state.historicTrips.length);
      state.historicTrips.push(...historicTrips);
    }
  },
  [RESET]: (state) => {
    state.trips.splice(0, state.trips.length);
    state.services.splice(0, state.services.length);
    state.historicTrips.splice(0, state.historicTrips.length);
  },
};

const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  setServices({ commit }, services) {
    commit(SET_SERVICES, services);
  },
  setTrips({ commit }, trips) {
    commit(SET_TRIPS, trips);
  },
  setHistoricTrips({ commit }, trips) {
    commit(SET_HISTORIC_TRIPS, trips);
  },
};

const getters = {
  historicTripsHome() {
    return [];
  },

  servicesNextBookings() {
    return state.services
      .filter((service) => !service.datePassed && (service.type === 2 || service.type === 3))
      .map((service) => {
        return {
          ...service,
          idScroller: service.id ? "service-" + service.id : "periodic-" + service.periodicId,
        };
      })
      .sort(sortByKeyValue("date"));
  },

  servicesPaused(state) {
    return state.services
      .filter(
        (service) =>
          (service.state === 3 && service.datePassed) ||
          (service.state === 90 && service.datePassed)
      )
      .map((service) => {
        return {
          ...service,
          idScroller: service.id ? "service-" + service.id : "periodic-" + service.periodicId,
        };
      })
      .sort(sortByKeyValue("date"))
      .reverse();
  },

  tripsDelivered() {
    return state.trips.filter((trip) => trip.state === 6 || trip.state === 12);
  },

  tripsPending(state) {
    return state.trips.filter(isPending).sort(sortByKeyValue("service.date")).reverse();
  },

  historicTrips(state) {
    return state.historicTrips
      .filter((trip) => trip.state !== 21)
      .sort(sortByKeyValue("service.date"))
      .reverse();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
